
import {
	Component,
	Vue
} from 'vue-property-decorator';
import Switch from '@/components/switch.vue';
import PageFooter from '@/components/page-footer.vue';
import previewImg from "@/components/previewImg.vue"
import CollapseItem from '@/components/collapse.vue';
import {
	myPageAdvertisementlist,
	productproductSpecialSave,
	productproductSpecialDelete,
	custompagecustompagelist,
	productfilterBoxList,
	systemPagelist,
	myPageAdvertisementdetail,
	myPageAdvertisementsave,
	myPageAdvertisementdelete,
	mallregisterSuccessConfig,
	mallregisterSuccessConfigSave,
	couponPriceNameTypeSave,
	personalCenterAddMenuConfigSave,
	personalCenterAddMenuConfigList
} from '@/api/material'
import {
	productList,
	productCategory
} from '@/api/supplier'
import {
	getOssToken
} from '@/api/user'
import Message from '@/components/message.vue'
import { imgHost } from '@/utils/config'
import Dialog from '@/components/dialog.vue';
import UploadImg from '@/components/upload-img.vue';
import PickerDate from '@/components/picker-date.vue';
import ChoosePages from '@/components/choosepages/choosepages.vue';
import draggable from 'vuedraggable'
import {
	getSearchDate,
	nextDay,
	chooseLinkConvert,
	getDataConvert
} from "@/utils/index"

import {
	UserModule
} from "@/store/modules/user"

@Component({
	name: 'operation-banner',
	components: {
		PickerDate,
		PageFooter,
		'slz-switch': Switch,
		'slz-dialog': Dialog,
		UploadImg,
		previewImg,
		CollapseItem,
		'slz-message': Message,
		ChoosePages,
		draggable
	}
})
export default class OperationBanner extends Vue {
	private imgUrl = imgHost;
	private filterTime = ''
	private keyword = '';
	private isOpen = false;
	private pageNo = 1;
	private pageSize = 10;
	private list: any = [];
	private total = 0;
	private bannerIdKey = '';
	private showDialog = false;
	private currentId = 0;
	private operationShow = false
	private operationloading = false
	private loading = false
	private rowmsg: any = {
		Id: 0,
		IsDisplay: true,
		ImgUrl: '',
		RelationType: '',
		RelationTypeValue: '',
		StartTime: '',
		EndTime: '',
		RelationId: '',
		RelationValue: '',
		AgentRegisterSuccessShowText: '',
		AgentRegisterSuccessShowImg: '',
	}
	private token: any = {}
	private typelist: any = [
		{ value: 1, label: '商品关联' },
		{ value: 4, label: '商品分类' },
		{ value: 5, label: '自定义页面' },
		{ value: 6, label: '系统页面' },
	]
	private classityList: any = []
	private shoplist: any = []
	private renderingshow = false
	private pageList: any = []
	private systempage: any = []
	private delShow = false
	private currentUrl = '';

	private form: any = {
		CustomerRegisterSuccessShowText: '',
		CustomerRegisterSuccessShowImg: '',
		CouponPriceNameType: 0
	}
	private formloading = false
	private chooseShow = false
	private chooseMsg: any = {}

	private couponTextType = 0;
	private selectIndex = -1;


	private minePageConfig = [];


	private mounted() {
		this.filterTime = [getSearchDate(2, false, -7)[0], getSearchDate(2)[0]].join('/')
		this.getform();
		this.getList();
		this.getMenuConfig();
		this.couponTextType = UserModule.mallInfo.CouponPriceNameType;
		// console.log(UserModule.mallInfo.CouponPriceNameType)
	}

	private async getMenuConfig(){
		try {
			this.formloading = true
			let res: any = await personalCenterAddMenuConfigList({})
			if (res.IsSuccess) {
				this.minePageConfig = res.Result;
			}
		} finally {
			this.formloading = false
		}
	}
	private async handleSaveMenuConfig(){
		let str = '';
		this.minePageConfig.map(item=>{
			if (str === ''){
				if (!item.Text){
					str = '请输入菜单名字'
				}else if (!item.Icon){
					str = '请上传菜单图标'
				}else if(!item.RelationId){
					str = '请设置跳转链接'
				}
			}
		})

		if (str){
			this.$message.error(str);
			return;
		}

		this.minePageConfig.map((item, index)=>{
			item.Sort = index;
			return item;
		})

		try {
			this.formloading = true
			let res: any = await personalCenterAddMenuConfigSave({PersonalCenterAddMenuConfigSaveDtos:this.minePageConfig })
			if (res.IsSuccess) {
				this.$message.success('操作成功')
			}
		} finally {
			this.formloading = false
		}
		
	}
	private handleAddMenu(){
		if(this.minePageConfig.length >= 10){
			this.$message.error('最多添加10个菜单');
			return;
		}
		this.minePageConfig.push({
			Id: 0,// (int): Id,
			Sort: 0,// (int): 排序,
			Text: '',// (string, optional): 菜单名称,
			Icon: '',// (string, optional): 菜单图标,
			RelationType: 0,// (int) = ['不关联:0' or '商品关联:1' or '商品分类:4' or '页面:5' or '系统页面:6' or '大转盘抽奖:7' or '签到活动:8' or '任务奖励活动:9' or '邀友有礼:10' or '小程序链接:11']: 关联类型,
			RelationTypeValue: '',// (string, optional): 关联类型展示,
			RelationId: '',// (int): 关联Id,
			RelationValue: '',// (string, optional): 关联项,
			JumpPath: '',// (string, optional): 页面跳转路径,
			IsJumpExternalWxApp: false,// (boolean): 是否跳转外部小程序--RelationType类型是小程序链接时使用,
			ExternalWxAppId: '',// (string, optional): 外部小程序AppId--RelationType类型是小程序链接时使用,
			ExternalWxAppOriginalId: '',// (string, optional): 外部小程序原始Id--RelationType类型是小程序链接时使用,
			JumpPageName: '',// (string, optional): 跳转页面名称--RelationType类型是小程序链接时使用
		})
	}

	private handleDeleteMenu(index){
		this.minePageConfig.splice(index, 1);
	}

	private async saveCouponTextType() {
		try {
			this.formloading = true
			let res: any = await couponPriceNameTypeSave({ CouponPriceNameType: this.couponTextType })
			if (res.IsSuccess) {
				this.$message.success('保存成功')
			}
		} finally {
			this.formloading = false
		}
	}

	private clearValue(e) {
		if (e !== null){
			this.minePageConfig[e].RelationType = 0
			this.minePageConfig[e].RelationTypeValue = ''
			this.minePageConfig[e].RelationId = ''
			this.minePageConfig[e].RelationValue = ''
			this.minePageConfig[e].JumpPath = ''
			this.minePageConfig[e].IsJumpExternalWxApp = false
			this.minePageConfig[e].ExternalWxAppId = ''
			this.minePageConfig[e].ExternalWxAppOriginalId = ''
			this.minePageConfig[e].JumpPageName = ''
		}else{
			this.rowmsg.RelationType = ''
			this.rowmsg.RelationTypeValue = ''
			this.rowmsg.RelationId = ''
			this.rowmsg.RelationValue = ''
			this.rowmsg.JumpPath = ''
			this.rowmsg.IsJumpExternalWxApp = false
			this.rowmsg.ExternalWxAppId = ''
			this.rowmsg.ExternalWxAppOriginalId = ''
			this.rowmsg.JumpPageName = ''
		}
		
		this.chooseMsg = {}
	}
	private getdata(e) {
		console.log(e)
		this.chooseMsg = e;

		if (this.selectIndex !== -1){
			this.minePageConfig[this.selectIndex].RelationType = getDataConvert(e.pagetype, e.subdivideType)

			this.minePageConfig[this.selectIndex].RelationTypeValue = e.pagetypelabel
			this.minePageConfig[this.selectIndex].RelationId = e.Id
			this.minePageConfig[this.selectIndex].RelationValue = e.label

			this.minePageConfig[this.selectIndex].JumpPath = e.pageurl
			this.minePageConfig[this.selectIndex].IsJumpExternalWxApp = e.IsJumpExternalWxApp
			this.minePageConfig[this.selectIndex].ExternalWxAppId = e.ExternalWxAppId
			this.minePageConfig[this.selectIndex].ExternalWxAppOriginalId = e.ExternalWxAppOriginalId
			this.minePageConfig[this.selectIndex].JumpPageName = e.label
		}else{
			this.rowmsg.RelationType = getDataConvert(e.pagetype, e.subdivideType)

			this.rowmsg.RelationTypeValue = e.pagetypelabel
			this.rowmsg.RelationId = e.Id
			this.rowmsg.RelationValue = e.label

			this.rowmsg.JumpPath = e.pageurl
			this.rowmsg.IsJumpExternalWxApp = e.IsJumpExternalWxApp
			this.rowmsg.ExternalWxAppId = e.ExternalWxAppId
			this.rowmsg.ExternalWxAppOriginalId = e.ExternalWxAppOriginalId
			this.rowmsg.JumpPageName = e.label
		}

		
		this.chooseShow = false
	}
	private async getform() {
		try {
			this.formloading = true
			let res: any = await mallregisterSuccessConfig({})
			if (res.IsSuccess) {
				this.form = res.Result;
			}
		} finally {
			this.formloading = false
		}
	}
	private async saveform() {
		try {
			this.formloading = true
			let res: any = await mallregisterSuccessConfigSave(this.form)
			if (res.IsSuccess) {
				this.$message.success('操作成功')
			}
		} finally {
			this.formloading = false
		}
	}
	private UploadForm(list, key) {
		this.form[key] = list[0] || ''
	}
	private uploadMineConfigIcon(list, index) {
		this.minePageConfig[index].Icon = list[0] || '';
	}
	private showimg(img) {
		this.currentUrl = img
		this.renderingshow = true
	}
	private emptyTime() {
		this.filterTime = ''
		this.getList()
	}
	private async addConfirm() {
		if (!this.rowmsg.ImgUrl) {
			this.$message.error('请上传图片')
			return
		}
		// else if(!this.rowmsg.RelationId){
		// 	this.$message.error('请选择关联项')
		// 	return
		// }
		if ((this.rowmsg.StartTime && !this.rowmsg.EndTime) || (!this.rowmsg.StartTime && this.rowmsg.EndTime)) {
			this.$message.error('请完善显示时间段')
			return
		} else if (new Date(this.rowmsg.StartTime).getTime() > new Date(this.rowmsg.EndTime).getTime()) {
			this.$message.error('结束时间不可早于开始时间')
			return
		}
		let data = JSON.parse(JSON.stringify(this.rowmsg))
		data.RelationType = data.RelationType || 0
		try {
			this.operationloading = true
			let res = await myPageAdvertisementsave(data)
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.addCancel()
				this.getList()
			}
		} finally {
			this.operationloading = false
		}
	}
	private addCancel() {
		this.operationShow = false
		this.rowmsg = {
			Id: 0,
			IsDisplay: true,
			ImgUrl: '',
			RelationType: null,
			StartTime: '',
			EndTime: '',
			RelationId: '',
			Sort: ''
		}
	}

	private async getToken() {
		try {
			const res: any = await getOssToken({})
			this.token = {
				AccessKeySecret: res.access_key_secret,
				OSSAccessKeyId: res.access_key_id,
				SecurityToken: res.security_token
			}
		} catch (e) {
			// console.log('getOssToken ===>', e)
		}
	}
	private changetype(record, e) {
		if (e !== null){
			this.selectIndex = e;
			this.chooseMsg = {
				...chooseLinkConvert(record.RelationType),
				...record,
				Id: record.RelationId
			}
		}else{
			this.selectIndex = -1;
		}
		
		this.chooseShow = true
	}
	private handleUpload(list) {
		this.rowmsg.ImgUrl = list[0] || ''
	}

	// 清空搜索
	private clearSearch() {
		this.pageNo = 1;
		this.filterTime = ''
		this.getList();
	}

	private doSearch() {
		this.pageNo = 1;
		this.getList();
	}

	// 跳转到详情页面
	private async toDetail(type: string, row?: any) {
		this.operationShow = true
		if (row.Id) {
			await this.getdetail(row)
		} else {
			this.rowmsg = {
				Id: 0,
				IsDisplay: true,
				ImgUrl: '',
				RelationType: '',
				RelationTypeValue: '',
				StartTime: '',
				EndTime: '',
				RelationId: '',
				RelationValue: '',
				JumpPath: '',
				IsJumpExternalWxApp: false,
				ExternalWxAppId: '',
				ExternalWxAppOriginalId: '',
			}
			this.chooseMsg.pagetype = 1
		}
	}
	private async getdetail(row) {
		try {
			let res = await myPageAdvertisementdetail({
				Id: row.Id
			})
			if (res.IsSuccess) {
				let msg = JSON.parse(JSON.stringify(res.Result))
				this.chooseMsg = {
					...chooseLinkConvert(msg.RelationType),
					...msg,
					Id: msg.RelationId
				}
				this.rowmsg = {
					...msg,
					RelationId: msg.RelationId || '',
					RelationType: msg.RelationType || '',
					RelationValue: msg.RelationValue || '',
					JumpPath: msg.JumpPath || '',
					IsJumpExternalWxApp: msg.IsJumpExternalWxApp || false,
					ExternalWxAppId: msg.ExternalWxAppId || '',
					ExternalWxAppOriginalId: msg.ExternalWxAppOriginalId || '',
					JumpPageName: msg.JumpPageName || '',
				}
			}
		} finally {
			//
		}
	}

	// 修改页面
	private changePage(e) {
		this.pageNo = e;
		this.getList();
	}
	todel(row) {
		this.rowmsg = row
		this.delShow = true
	}
	// 删除
	private async showDeleteDialog() {
		try {
			this.loading = true
			let res = await myPageAdvertisementdelete({ Id: await this.rowmsg.Id })
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.getList()
			}
		} finally {
			this.loading = false
		}
	}
	private changeCurrent(val) {
		this.pageNo = val;
		this.getList();
	}
	// 获取列表
	private async getList() {
		try {
			this.loading = true
			let data: any = {
				// Id:0,
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize,
			}
			const res: any = await myPageAdvertisementlist(data)
			if (res.IsSuccess) {
				this.list = res.Result.Results
				this.total = res.Result.Total;
			}
		} finally {
			this.loading = false
		}
	}

	// 设置状态
	private async handleShow(e: boolean, item: any) {
		this.rowmsg = item
		this.addConfirm()
	}
}
